import type { PricingIndicatorStatus } from '../../../../../components/PricingIndicator/PricingIndicatorIconText/PricingIndicatorIconText.typed';

const PRICING_INDICATOR_TRACKING_NAME: Record<PricingIndicatorStatus, string> =
  {
    ABOVE: 'above average',
    SAME: 'at average',
    BELOW: 'below average',
  };

export type FinanceTrackingParams = {
  priceIndicator?: { state: PricingIndicatorStatus };
  userId?: string;
  sellerType?: string;
  section?: string;
  location?: string;
  mainSection?: string;
  trustedDealer?: boolean;
};

export const appendFinanceTrackingParams = (
  url: string,
  params: FinanceTrackingParams,
): string => {
  if (!url) return url;

  const {
    priceIndicator,
    userId,
    sellerType,
    section,
    location,
    mainSection,
    trustedDealer,
  } = params;

  const [path, existingQuery = ''] = url.split('?');
  const search = new URLSearchParams(existingQuery);

  if (priceIndicator?.state)
    search.set(
      'pricingIndicator',
      PRICING_INDICATOR_TRACKING_NAME[priceIndicator.state],
    );
  if (userId) search.set('userId', userId);
  if (sellerType) search.set('sellerType', sellerType);
  if (section) search.set('section', section);
  if (location) search.set('location', location);
  if (mainSection) search.set('mainSection', mainSection);
  if (trustedDealer !== undefined)
    search.set('trustedDealer', String(trustedDealer));

  const query = search.toString();
  return query ? `${path}?${query}` : path;
};
